export const CLIENT_METADATA_HEADER = {
  CLIENT_TYPE: "X-Client-Type",
  CLIENT_VERSION: "X-Client-Version",
  SALE_CHANNEL_CODE: "X-Sale-Channel-Code",
};

// Web Vận hành chỉ chạy trên browser nên client type là hằng số
export const CLIENT_TYPE = "ops-web";

// Version của app: field `version` trong apps/fulfillment/package.json, bump thủ công.
// Cả CI lẫn script `start:*` ở root đều đọc field đó ra biến này, nên chạy local cũng gửi
// đúng version như bản deploy.
export const CLIENT_VERSION = process.env.REACT_APP_CLIENT_VERSION;

// Chốt giá trị `Web` (Title Case, không phải `WEB`). Đọc từ env để đổi được mà không
// phải sửa code,
export const SALE_CHANNEL_CODE = process.env.REACT_APP_SALE_CHANNEL_CODE || "Web";
